export const DEFAULT_COUNTRY = 'US';
